import { render, staticRenderFns } from "./ReportContent.vue?vue&type=template&id=2a7849f0&scoped=true"
import script from "./ReportContent.vue?vue&type=script&lang=js"
export * from "./ReportContent.vue?vue&type=script&lang=js"
import style0 from "./ReportContent.vue?vue&type=style&index=0&id=2a7849f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7849f0",
  null
  
)

export default component.exports